/**
 * The ticket emails' link (TMMAPP-0142 §G U2): tmm-api links to `<app origin>/assistant`, and the
 * app's route is `/me/assistant`. This replaces the one with the other, keeping the query, so
 * `/assistant?ticket={number}` opens Help & feedback on that ticket.
 */
import { Navigate, useLocation } from 'react-router-dom';

export function AssistantLinkRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/me/assistant${search}`} replace />;
}
